"use client";

import React from "react";
import { MoreVertical } from "lucide-react";
import { cn } from "utils/utils";
import { useDropdownMenu } from "modules/common/components/ui/hooks/useDropdownMenu";
import { CardActionsMenu } from "./CardActionsMenu";
import { ActionButtonsProps } from "./types";
import { ICON_SIZE } from "modules/common/components/navigation/Menu";

export function CardActionButtons({
  actions,
  disabled = false,
  className,
  buttonClassName,
  title,
  icon,
}: ActionButtonsProps) {
  const {
    buttonRef,
    closeMenu,
    handleButtonClick,
    menuPos,
    menuRef,
    showMenu,
  } = useDropdownMenu();

  return (
    <div className={cn("flex justify-center", className)}>
      <button
        ref={buttonRef}
        onClick={(e) => handleButtonClick(e, actions.length)}
        className={cn(
          "btn btn-circle btn-ghost btn-sm",
          buttonClassName,
          // opacity, not just btn-disabled: daisyUI exempts btn-ghost from the
          // disabled background dim, so its only signal is --btn-fg — which the
          // icon's own `stroke-primary` (and any custom `icon`) overrides.
          disabled && "btn-disabled opacity-40"
        )}
        aria-label={title}
        aria-haspopup="menu"
        aria-expanded={showMenu}
        disabled={disabled}
      >
        {icon ? (
          icon
        ) : (
          <MoreVertical size={ICON_SIZE} className="stroke-primary" />
        )}
      </button>

      <CardActionsMenu
        actions={actions}
        isOpen={showMenu}
        position={menuPos}
        onClose={closeMenu}
        menuRef={menuRef}
        title={title}
      />
    </div>
  );
}
